import * as React from 'react';
import { button } from './applePayButtonCssDefs';

interface ApplePayButtonProps {
  onClick: () => Promise<unknown>;
}

const ApplePayButton: React.VFC<ApplePayButtonProps> = ({ onClick }) => {
  const [disabled, setDiabled] = React.useState<boolean>(false);

  const handleClick = (e: React.MouseEvent) => {
    // prevents multiple onClick calls when clicked multiple times
    if (!disabled && e.detail === 1) {
      setDiabled(true);
      onClick().finally(() => setDiabled(false));
    }
  };

  return (
    <button
      css={button}
      type="button"
      disabled={disabled}
      onClick={handleClick}
      data-testid="apple-pay-button"
    >
      <div className="apple-pay-button-with-text apple-pay-button-black-with-text">
        <span className="text"></span>
        <span className="logo"></span>
      </div>
    </button>
  );
};

export default ApplePayButton;
